import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Card, Checkbox, FlexGap, Paragraph, tokens } from '@treams/treams-ui';

export default function FeedbackComposerCompetencyCard(props: {
	competency: graphql.Competency;
	selected: boolean;
	onChange: (selected: boolean, text?: string) => void;
}) {
	const { localize } = useLocalize();

	if (!('id' in props.competency)) {
		return null;
	}

	return (
		<Card
			onClick={() => props.onChange(props.selected)}
			selected={props.selected}
			p={`${tokens.padding.compact}px`}
			chevron={false}
		>
			<FlexGap alignItems="center" justifyContent="space-between" gap={tokens.gap.element}>
				<Paragraph flex={1} minWidth={0}>
					{localize(props.competency.title!).text}
				</Paragraph>
				<Box
					flexShrink={0}
					onClick={(event) => {
						event.stopPropagation();
						props.onChange(props.selected);
					}}
				>
					<Checkbox checked={props.selected} />
				</Box>
			</FlexGap>
		</Card>
	);
}
